import { render } from "./CompetitionHeader.vue?vue&type=template&id=50908f40&scoped=true"
import script from "./CompetitionHeader.vue?vue&type=script&lang=js"
export * from "./CompetitionHeader.vue?vue&type=script&lang=js"

import "./CompetitionHeader.vue?vue&type=style&index=0&id=50908f40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50908f40"]])

export default __exports__